import { Box } from '@mui/material'

export const columns = [
  {
    title: 'Societate',
    field: 'parentSocietyName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Denumire comerciala',
    field: 'businessName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nr. Registrul Comertului',
    field: 'regNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'CUI',
    field: 'vatId',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Adresa',
    field: 'fiscalAddress',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Iban',
    field: 'bankAccount',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Banca',
    field: 'bankName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Capital social',
    field: 'socialCap',
    align: 'left',
    type: 'string'
  }
]
